<mat-form-field appearance="fill" class="estimator-select">
  <mat-label>Select Estimator</mat-label>
  <mat-select
    [(value)]="selectedEstimator"
    (selectionChange)="selectEstimator($event)"
  >
    <mat-option></mat-option>
    <mat-option [value]="estimator" *ngFor="let estimator of estimators">{{
      estimator.username
    }}</mat-option>
  </mat-select>
</mat-form-field>
